import { render, staticRenderFns } from "./JobStatusCard.vue?vue&type=template&id=183a351f&scoped=true"
import script from "./JobStatusCard.vue?vue&type=script&lang=ts"
export * from "./JobStatusCard.vue?vue&type=script&lang=ts"
import style0 from "./JobStatusCard.vue?vue&type=style&index=0&id=183a351f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183a351f",
  null
  
)

export default component.exports